module.exports = __webpack_public_path__ + "staticcomp/img/cover.8ed1307.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3/3/cover.jpg
// module id = VkFM
// module chunks = 39